import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { of, Subscription, interval } from 'rxjs';

import { ClaimsService } from '@core/authentication/claims.service';
import {
  DialogButton,
  DialogButtonColour,
  DialogComponent
} from '@shared/components/dialog/dialog.component';
import { ModalSetting } from '@shared/components/modal/modal-setting';
import { AdviserLabelCase } from '@shared/pipes/adviser-label.pipe';

@Component({
  selector: 'spark-appbar',
  templateUrl: './appbar.component.html',
  styleUrls: ['./appbar.component.scss']
})
export class AppbarComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private authService: MsalService,
    private claimsService: ClaimsService,
    private modalService: BsModalService
  ) {}

  private modalRef: BsModalRef | null = null;

  private subscription!: Subscription;
  public currentDate: number = Date.now();
  adviserLabelCase = AdviserLabelCase;

  ngOnInit(): void {
    // refresh every 15mins
    this.subscription = interval(900000).subscribe((_) => {
      this.currentDate = Date.now();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public get userFullName(): string {
    return this.claimsService.userDisplayName;
  }

  public get userEmail(): string {
    return this.claimsService.userId;
  }

  public goToTasks(): void {
    this.router.navigate(['Tasks']);
  }

  private logout(): void {
    let activeAccount = this.authService.instance.getActiveAccount();
    this.authService.logoutRedirect({ account: activeAccount });
  }

  // TODO: replace with lds-dialog [ future release ]
  public showConfirm(): void {
    let actionBtns: DialogButton[] = [
      {
        label: 'Cancel',
        action: of([]),
        complete: () => this.modalRef?.hide(),
        colour: DialogButtonColour.default
      },
      {
        label: 'Yes, sign out',
        action: of([]),
        complete: () => this.logout(),
        colour: DialogButtonColour.action
      }
    ];

    const initialState = {
      title: 'Sure you want to sign out?',
      message: 'This will only sign you out of your account on this device.',
      buttons: actionBtns
    };

    this.modalRef = this.modalService.show(
      DialogComponent,
      ModalSetting.createDialog(initialState)
    );
  }
}
